<template>
  <div>
    <div class="box__header">
      <span class="box__header--text">
        Sekcje formularza
      </span>
    </div>
    <el-collapse class="formset__list">
      <div v-for="(section, i) in sections" class="formset__item">
        <el-collapse-item :name="i">
          <template slot="title">
            <formset-header
              :label="`${section.name_pl || 'Nowa sekcja'}`"
              :items.sync="sections"
              :errors="checkForErrors(errors, [i])"
              :index="i"
            />
          </template>
          <section-form
            :section.sync="section"
            :fieldTypes="fieldTypes"
            :errors="errors[i] || {}"
          />
        </el-collapse-item>
      </div>
    </el-collapse>
    <el-button @click="addSection" class="fluid" type="primary">
      dodaj sekcję
    </el-button>
  </div>
</template>
<script>
import SectionForm from '@/views/CustomForms/SectionForm'
import FormsetHeader from '@/views/CustomForms/formset/FormsetHeader'

export default {
  props: ['sections', 'errors', 'fieldTypes'],
  methods: {
    addSection() {
      if (this.sections === undefined) this.sections = []
      this.sections.push({ fields: [] })
    }
  },
  components: {
    SectionForm,
    FormsetHeader
  }
}
</script>
<style lang="scss"></style>
